(function(){
  document.addEventListener('DOMContentLoaded', function() {
    window.colorsSlider = function colorsSlider() {
      if ( document.querySelector('.js-card-color-slider') ) {
        new Swiper('.js-card-color-slider', {
          slidesPerView: 'auto',
          spaceBetween: 5,
          centeredSlides: false,
          // loop: true,
          initialSlide: 1,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          // freeMode: true,
        });
      }
    }
    window.colorsSlider();

  });
})();